export const PEEK_BOX_TEXT = {
  title: 'Peek inside the box',
  bullets: [
    'Perfectly-portioned ingredients',
    'We always buy high quality, 100% British fresh meat, where possible',
    'Quality produce from trusted suppliers',
    'Easy-to-follow recipe cards',
  ],
}
